
import styled from 'styled-components';

export const MenubarContainer = styled.div`
*{
    user-select: none;
}
.menubar_sections {
    position: relative;
   
}
.menubar_button {
    margin: 4px;
}
.menubar_button  svg{
    width: 48px;
    height: 48px;
}
.menu_icons {
    background-color: #33363C;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 8px;
    width: 48px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
}
.menu_icons svg{
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-color: #33363C;
}
.menu_icons svg:hover{
    background-color: #797f8c;
}
.menu_icons .active svg{
    background-color: #36BDBE;
}
.menu_icons .active svg path{
    stroke: #000000;
}
.menu-container {
    // position: fixed;
    // left: 1%;
    // top: 1%;
}
.menubar_container_wrapper{
    position: fixed;
    left: 10px;
    top: 115px;
    display: flex;
}
.map_toggle_box{
    position: fixed;
    left: 15px;
    top: 60px;
    display: flex;
    cursor: pointer;
}
.map_toggle_box:hover svg{
    background-color: #36BDBE;
}
.map_toggle_box:hover path{
    stroke: #000000;
}
.map_toggle_box svg{
    width: 48px;
    height: 48px;
    background-color: #33363c;
    border-radius: 4px;
}
.map_toggle_box rect{
    fill-opacity: 0;
}
`;